// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "service_hasProducts-2sWZG";
var _3 = "service_canAdd-TVOhY";
var _4 = "service__totalPrice-3WDHT";
export { _1 as "__esModule", _2 as "service_hasProducts", _3 as "service_canAdd", _4 as "service__totalPrice" }
export default { "__esModule": _1, "service_hasProducts": _2, "service_canAdd": _3, "service__totalPrice": _4 }
